export const SET_CAR_TYPE = 'SET_CAR_TYPE';
export const SET_SELECTED_PACKAGE = 'SET_SELECTED_PACKAGE';
export const SET_SERVICE_PACKAGE_STATE = 'SET_SERVICE_PACKAGE_STATE';
